import React from 'react';
import { withRouter } from 'react-router-dom';
import Tabs from '../../../common/components/Tabs';
import {
  Events,
  Competitions,
  Teams,
  Workshops,
  PurchaseOrders,
  TechnicalControl,
  Tournaments,
  CsvImport
} from '../../containers';

const panes = [
  {
    title: 'Events',
    path: '/admin/events',
    contents: <Events/>
  },
  {
    title: 'Comp. & Works.',
    path: '/admin/competitions',
    contents: <Competitions/>
  },
  {
    title: 'Teams',
    path: '/admin/teams',
    contents: <Teams/>
  },
  {
    title: 'Works. Reg.',
    path: '/admin/workshops',
    contents: <Workshops/>
  },
  {
    title: 'Tech Contr.',
    path: '/admin/tc',
    contents: <TechnicalControl/>
  },
  {
    title: 'POs',
    path: '/admin/pos',
    contents: <PurchaseOrders/>
  },
  {
    title: 'Schedules',
    path: '/admin/schedules',
    contents: <Tournaments/>
  },
  {
    title: 'CSV',
    path: '/admin/csv',
    contents: <CsvImport/>
  }
];

const Dashboard = () => <Tabs panes={panes}/>;

export default withRouter(Dashboard);




// WEBPACK FOOTER //
// ./src/private/admin/components/Dashboard/index.js